type RoleLike = string | { name?: string; slug?: string; role?: string };

const ADMIN_ROLE_KEYS = new Set([
  "super admin",
  "super-admin",
  "super_admin",
  "admin",
  "hr",
]);

const MANAGER_ROLE_KEYS = new Set(["manager"]);

const normalizeRole = (value: unknown): string | null => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim().toLowerCase();
  return trimmed.length > 0 ? trimmed : null;
};

const extractRoleKey = (role: RoleLike): string | null => {
  if (typeof role === "string") {
    return normalizeRole(role);
  }

  return normalizeRole(role.name) ?? normalizeRole(role.slug) ?? normalizeRole(role.role);
};

export const extractRoleKeys = (roles: unknown): string[] => {
  if (!Array.isArray(roles)) {
    return [];
  }

  return roles
    .map((role) => extractRoleKey(role as RoleLike))
    .filter((role): role is string => Boolean(role));
};

export const isAdminFromRoleKeys = (roleKeys: string[]): boolean => {
  return roleKeys.some((role) => {
    if (ADMIN_ROLE_KEYS.has(role)) {
      return true;
    }

    if (role.includes("admin")) {
      return true;
    }

    return /(^|[-_\s])hr($|[-_\s])/.test(role);
  });
};

export const isManagerFromRoleKeys = (roleKeys: string[]): boolean => {
  return roleKeys.some((role) => MANAGER_ROLE_KEYS.has(role) || role.includes("manager"));
};
